import SubmitSkeleton from "../SubmitSkeleton";
import MediaDropzone from "../../common/MediaDropZone";
import { useCaseContext } from "../../../context/CaseContext";
import CustomLabel from "../../common/CustomLabel";
import { IncidentDescription } from "../../../types";

import RecordView from "../RecordView";
import { useState } from "react";

const IncidentNarrationStage = ({
  setStep,
}: {
  setStep: (step: number) => void;
}) => {
  const { incidentDescription, updateCaseData } = useCaseContext();
  const [errorMessage, setErrorMessage] = useState("");

  const handleIncidentDescription = (
    field: keyof IncidentDescription,
    value: any
  ) => {
    updateCaseData("incidentDescription", {
      ...incidentDescription,
      [field]: value,
    });
    setErrorMessage("");
  };

  // Handle photo evidence files
  const handlePhotoEvidenceChange = (files: File[]) => {
    handleIncidentDescription(
      "incidentPhotoEvidence",
      files.length > 0 ? files : null
    );
  };

  const canProceed =
    incidentDescription &&
    incidentDescription.incidentNarration &&
    incidentDescription.incidentNarration.length > 0;

  const handleNext = () => {
    if (!canProceed) {
      setErrorMessage("Please enter incident description before proceeding.");
      return;
    }
    setErrorMessage("");
    setStep(6);
  };

  return (
    <SubmitSkeleton
      title="In your words, narrate how the incident happened"
      onPrev={() => setStep(4)}
      onNext={handleNext}
      canProceed={!!canProceed}
      progress={5 / 10}
    >
      <div className="flex flex-col gap-4">
        {errorMessage && (
          <p className="text-red-500 text-sm mb-1">{errorMessage}</p>
        )}
        <CustomLabel labelText="Incident description" isRequired>
          <textarea
            placeholder="Describe the incident"
            className="h-[232px] w-full py-[15.5px] px-[18px] border border-gray-3 rounded-[10px] font-medium text-gray-7 text-sm leading-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent mt-1"
            onChange={(e) =>
              handleIncidentDescription("incidentNarration", e.target.value)
            }
            value={incidentDescription.incidentNarration as string | ""}
          />
          <p className="font-normal text-xs leading-3 text-gray-4 px-1 mt-1">
            There are no character limits{" "}
          </p>
        </CustomLabel>

        <CustomLabel labelText="Voice narration of incident (Optional)">
          <RecordView />
        </CustomLabel>

        <CustomLabel labelText="Abuse evidence (Optional)">
          <MediaDropzone
            contextField="incidentPhotoEvidence"
            onFileChange={handlePhotoEvidenceChange}
            existingFiles={
              incidentDescription.incidentPhotoEvidence ?? undefined
            }
            acceptedTypes={[
              "image/jpeg",
              "image/png",
              "image/gif",
              "video/mp4",
            ]}
            label="Drop your evidence photos or videos here"
          />
        </CustomLabel>
      </div>
    </SubmitSkeleton>
  );
};

export default IncidentNarrationStage;
